<script setup lang="ts">
  defineOptions({ name: 'CPGlobalErrorTopBar' })

  import { defineAsyncComponent } from 'vue'

  import { clearError } from 'nuxt/app'

  import { useAuth } from '@common/auth-layer/composables/useAuth'
  import { useCPNavigation } from '@common/navigation-layer/composables/useNavigationContext'
  import TopBar from '@common/shared-ui-layer/components/TopBar.vue'
  import TopBarMobile from '@common/shared-ui-layer/components/TopBarMobile.vue'
  import { GLOBAL_ERROR_ELEMENT_IDS } from '@common/shared-ui-layer/constants/global-error.constants'

  import { useCPSwitcherSidebar } from '@clientportal/portal-shell-layer/composables/useCPSwitcherSidebar'
  import { useCPRouteContext } from '../composables/useCPRouteContext'

  import CPPortalBrandHomeLink from './CPPortalBrandHomeLink.vue'

  const LoginModal = defineAsyncComponent(() => import('@clientportal/auth-layer/components/LoginModal.vue'))

  const { isMobile } = useCPRouteContext()
  const { portalIcon, portalName, portalSubtitle } = useCPSwitcherSidebar()
  const { store: authStore } = useAuth()
  const { CPNavigateTo } = useCPNavigation()

  const handleSignup = () => {
    authStore.openLoginModal('SIGN_UP')
  }

  const handlePortalHomeClick = async () => {
    await clearError()
    await CPNavigateTo({ name: 'clientportal-dashboard' })
  }
</script>

<template>
  <div :id="GLOBAL_ERROR_ELEMENT_IDS.HEADER">
    <TopBar
      v-if="!isMobile"
      class="cp-topbar"
      :show-bottom-border="true"
      :compact-left-section="true"
      :show-profile-card="true"
      @login-click="authStore.openLoginModal()"
      @signup-click="handleSignup"
    >
      <template #logo>
        <CPPortalBrandHomeLink
          :portal-icon="portalIcon"
          :portal-name="portalName"
          :portal-subtitle="portalSubtitle"
          class="max-w-[16rem]"
          @click="handlePortalHomeClick"
        />
      </template>
    </TopBar>

    <TopBarMobile
      v-else
      class="h-full w-full"
      :show-bottom-border="true"
      :show-logo="false"
      :show-search="false"
      @login-click="authStore.openLoginModal()"
      @signup-click="handleSignup"
    >
      <template #center>
        <CPPortalBrandHomeLink
          :portal-icon="portalIcon"
          :portal-name="portalName"
          :portal-subtitle="portalSubtitle"
          class="min-w-0 flex-1"
          @click="handlePortalHomeClick"
        />
      </template>
    </TopBarMobile>

    <LoginModal />
  </div>
</template>
